<template>
  <sonko-layout>
    <vue-headful title="eWak" />
    <v-layout row wrap class="ml-3 pa-1">
      <!-- required data notice -->
      <v-flex>
        <v-alert
          :value="true"
          type="info"
        >Please update your location and expertise of interest first to get experts for your jobs.</v-alert>
      </v-flex>
      <!-- end of notice  -->

      <!-- expertise -->
      <v-flex xs12 class="list-section">
        <v-toolbar dense flat color="sectionColor">Expertise</v-toolbar>
        <expertise></expertise>
      </v-flex>
      <!-- End -->

      <!-- Location -->
      <v-flex xs12 class="list-section mt-3">
        <v-toolbar dense flat color="sectionColor">Location</v-toolbar>
        <locations></locations>
      </v-flex>
      <!-- End -->

    </v-layout>
  </sonko-layout>
</template>

<script>
import { mapGetters } from "vuex";
import BioData from "./_components/bio_data.vue";
import Expertise from "./_components/expertise.vue";
import Locations from "./_components/locations.vue";
export default {
  name: "ExpertProfileIndex",
  components: {
    BioData,
    Expertise,
    Locations
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
